var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { app: true, active: _vm.is_active } },
    [
      _vm.is_loading ? _c("Loader") : _vm._e(),
      _vm._v(" "),
      [
        _vm._l(_vm.local_steps, function(step, key) {
          return _vm.local_steps.length > 0
            ? [
                step && step.step_type === "start" && _vm.current_step == key
                  ? _c("ElementStart", {
                      key: key,
                      attrs: {
                        step: step,
                        "current-step": _vm.getCurrentStep(key)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                step && step.step_type === "text" && _vm.current_step == key
                  ? _c("ElementText", {
                      key: key,
                      attrs: {
                        step: step,
                        "current-step": _vm.getCurrentStep(key)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                step &&
                step.step_type === "step" &&
                (_vm.current_step == key || _vm.current_step > 1)
                  ? _c("ElementSelect", {
                      key: key,
                      attrs: {
                        step: step,
                        steps: _vm.local_steps,
                        "current-step": _vm.getCurrentStep(key),
                        "max-steps": _vm.max_step
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                step && step.step_type === "product"
                  ? _c("ElementProduct", {
                      key: key,
                      attrs: {
                        step: step,
                        steps: _vm.local_steps,
                        "current-step": _vm.getCurrentStep(key),
                        "max-steps": _vm.max_step,
                        path: _vm.path
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                step && step.step_type === "product-compare"
                  ? _c("ElementProductCompare", {
                      key: key,
                      attrs: {
                        step: step,
                        steps: _vm.local_steps,
                        "current-step": _vm.getCurrentStep(key),
                        "max-steps": _vm.max_step,
                        path: _vm.path
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }